import React from "react";
import SEO from "../components/SEO";
import { PageHero, SectionHeading, FeatureCard, CTABand, Icon } from "../components/ui-blocks";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { insuranceProviders as ip, images } from "../mock/mock";

export default function InsuranceProviders() {
  return (
    <>
      <SEO
        title="Insurance Claims Cycle Management & Claims Processing Outsourcing"
        description="Outsource insurance claims cycle management to VerifiAssist. FNOL, case management, allocation, document management, risk and validation — reduce operations cost and settle claims faster."
        path="/for-insurance-providers"
      />
      <PageHero eyebrow={ip.hero.eyebrow} title={ip.hero.title} subtitle={ip.hero.subtitle} image={images[ip.hero.image]}>
        <div className="mt-8">
          <Button asChild size="lg" className="bg-brand-600 hover:bg-brand-700"><Link to="/contact-us">Contact Us Today <ArrowRight className="ml-1 h-4 w-4" /></Link></Button>
        </div>
      </PageHero>

      <section className="container-x py-16 sm:py-20">
        <SectionHeading center eyebrow="Why outsource" title="Transform your claims cycle management" subtitle="An increasing number of insurance leaders outsource claims processing to gain efficiency and cut cost." />
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {ip.benefits.map((b) => (
            <span key={b} className="inline-flex items-center gap-2 rounded-full border border-brand-100 bg-brand-50 px-4 py-2 text-sm font-medium text-brand-700">
              <Check className="h-4 w-4 text-brand-teal" /> {b}
            </span>
          ))}
        </div>
      </section>

      <section className="bg-slate-50">
        <div className="container-x py-16 sm:py-20">
          <SectionHeading center eyebrow="What we can do for you" title="End-to-end claims capabilities" />
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {ip.services.map((s) => <FeatureCard key={s.title} icon={s.icon} title={s.title} body={s.body} />)}
          </div>
        </div>
      </section>

      <section className="container-x py-16 sm:py-20">
        <SectionHeading center eyebrow="The advantage" title={ip.why.title} subtitle="Operating with skilled, experienced agents — reduce operations cost by up to 65% per year." />
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {ip.why.items.map((w) => (
            <div key={w.title} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-navy text-brand-teal"><Icon name={w.icon} className="h-5 w-5" /></div>
              <h3 className="mt-4 text-base font-semibold text-brand-navy">{w.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{w.body}</p>
            </div>
          ))}
        </div>
      </section>

      <CTABand title="Let us manage your insurance claims cycle" body="We integrate advanced claims processing with skilled professionals to deliver prompt, efficient claims management — helping you reduce cost and retain customers." primaryLabel="Contact Us Today" />
    </>
  );
}
